import React, {useState} from 'react'
import AuthPage from './AuthPage'
import {makeStyles} from '@mui/styles'
import {heading, inputRow} from './authStyles'
import {spaceExtraLarge, spaceMedium} from '../../assets/styles/spacing'
import {useHistory} from 'react-router-dom'
import {STATE_SENDING, STATE_SENT, STATE_IDLE} from './authConstants'
import RXRButton from '../RXRButton'
import Routes from '../../constants/RouteConstants'
import ChangePasswordInputs from './ChangePasswordInputs'

function ResetPassword(props) {
  const classes = useStyles()
  const history = useHistory()
  const [sendState, setSendState] = useState(STATE_IDLE)

  return (
    <AuthPage isLoading={sendState === STATE_SENDING}>
      {sendState === STATE_SENT ? (
        <React.Fragment>
          <p className={classes.heading}>You're all set!</p>
          <p className={classes.confirmationText}>You have successfully updated your password. You can now log in to RXO Home.</p>
          <RXRButton className={classes.backButton} onClick={() => history.push(Routes.LOGIN)}>
            Return to log-in
          </RXRButton>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <p className={classes.heading}>Reset Password</p>
          <ChangePasswordInputs
            ctaLabel={'Reset Password'}
            onStateChange={setSendState}
            errorHelperText={'Please go through the reset password flow again to receive a new link.'}
          />
        </React.Fragment>
      )}
    </AuthPage>
  )
}

const useStyles = makeStyles(theme => ({
  heading: heading,
  backButton: {
    marginTop: spaceMedium,
  },
  confirmationText: {
    ...inputRow,
    margin: `${spaceExtraLarge}px auto`,
  },
}))

export default ResetPassword
